
import { BOOKING_MARK_AS_COMPLETED, BOOKING_SERVICE_REMOVE, CANBOOKIN_LIST_REASON, CONTACT_SUPPORT, DASHBOARD_BOOKING_DETAIL, DASHBOARD_BOOKING_VIEW_DETAIL, DASHBOARD_DETAIL, DASHBOARD_MARK_AS_COMPLETED_BOOKING, DASHBOARD_STATUS_CHANGE_BOOKING, OFFLINE_BOOKING_CREATE, SERVICE_MANAGEMENT_ADD, SERVICE_MANAGEMENT_DELETE, SERVICE_MANAGEMENT_DETAIL, SERVICE_MANAGEMENT_LIST, SERVICE_MANAGEMENT_STATUS, SERVICE_MANAGEMENT_UPDATE } from "../Constants/DashboardConstants";
import { createGetDataReducer } from "./CommonReducer";

const ContactSupportReducer = createGetDataReducer(CONTACT_SUPPORT);
const AddServiceReducer = createGetDataReducer(SERVICE_MANAGEMENT_ADD);
const ServiceManagementListReducer = createGetDataReducer(SERVICE_MANAGEMENT_LIST);
const ServiceManagementDeleteReducer = createGetDataReducer(SERVICE_MANAGEMENT_DELETE);
const ServiceManagementStatusReducer = createGetDataReducer(SERVICE_MANAGEMENT_STATUS);
const ServiceManagementDetailReducer = createGetDataReducer(SERVICE_MANAGEMENT_DETAIL);
const ServiceManagementUpdateReducer = createGetDataReducer(SERVICE_MANAGEMENT_UPDATE);

const DashboardDetailGetReducer = createGetDataReducer(DASHBOARD_DETAIL);
const DashboardBookingDetailReducer = createGetDataReducer(DASHBOARD_BOOKING_DETAIL);
const DashboardBookingViewDetailReducer = createGetDataReducer(DASHBOARD_BOOKING_VIEW_DETAIL);
const DashboardBookinStatusChangeReducer = createGetDataReducer(DASHBOARD_STATUS_CHANGE_BOOKING);
const DashboardBookinMarkasCompletedReducer = createGetDataReducer(DASHBOARD_MARK_AS_COMPLETED_BOOKING);
const BookingServiceRemoveReducer = createGetDataReducer(BOOKING_SERVICE_REMOVE);
const BookingMarkAsCompletedReducer = createGetDataReducer(BOOKING_MARK_AS_COMPLETED);
const OfflineBookingCreateReducer = createGetDataReducer(OFFLINE_BOOKING_CREATE);





export const DashboardReducers = {
    ContactSupportState: ContactSupportReducer,

    AddServiceState: AddServiceReducer,
    ServiceManagementListState: ServiceManagementListReducer,
    ServiceManagementDeleteState: ServiceManagementDeleteReducer,
    ServiceManagementStatusState: ServiceManagementStatusReducer,
    ServiceManagementDetailState: ServiceManagementDetailReducer,
    ServiceManagementUpdateState: ServiceManagementUpdateReducer,
    DashboardDetailGetState: DashboardDetailGetReducer,
    DashboardBookingDetailState: DashboardBookingDetailReducer,
    DashboardBookingViewDetailState: DashboardBookingViewDetailReducer,
    DashboardBookingStatusChangeBookingState: DashboardBookinStatusChangeReducer,
    DashboardMarkAsCompletedState: DashboardBookinMarkasCompletedReducer,
    BookingServiceRemoveState: BookingServiceRemoveReducer,
    BookingMarkAsCompletedState: BookingMarkAsCompletedReducer,
    OfflineBookingCreateState: OfflineBookingCreateReducer,

}